import type { PayloadAction } from '@reduxjs/toolkit';
import { ProductsAPICall } from 'reactApp/api/billing/products/ProductsAPICall';
import { loggerSaga } from 'reactApp/modules/logger/logger.saga';
import { loadProductsList, ProductsListActions } from 'reactApp/modules/productsList/productsList.module';
import { callSagaFromAction } from 'reactApp/utils/callSagaFromAction';
import { sendXray } from 'reactApp/utils/ga';
import { call, put, takeEvery } from 'redux-saga/effects';

export const callProductsListApi = (products: string[]) =>
    new ProductsAPICall().makeRequest({
        products,
    });

function* loadProducts(listIds: string[]) {
    yield put(ProductsListActions.startLoading());

    try {
        const { data } = yield call(callProductsListApi, listIds);
        yield put(ProductsListActions.setProductsList(data.products));
    } catch (error: any) {
        sendXray(['blng', 'products', 'error']);
        yield put(ProductsListActions.hasError());
        yield loggerSaga({ error });
    }
}

export const handleLoadProducts = (payload: PayloadAction<string[]>) => callSagaFromAction(loadProducts, payload);

export function* watchProductsListRoot() {
    yield takeEvery(loadProductsList.toString(), handleLoadProducts);
}
